module.exports = __webpack_public_path__ + "img/default_img_6.09955e07.png";